import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const ToolbarListItem = styled.li`
  display: flex;
  justify-content: flex-start; /* flex-start is flex-end due to rtl*/
  padding: 0rem 0.5rem;

  list-style: none;
  & + li {
    border-top: 1px solid rgba(237, 237, 237, 0.1);
  }
`;

const ToolbarIcon = styled.div`
  margin-left: 1rem;
`;

const ToolbarButton = styled.button`
  display: flex;
  width: 100%;
  align-items: center;
  height: 3rem;
  flex-direction: row;
  color: #fff;
  opacity: 0.5;
  direction: rtl;
  width: inherit;
  white-space: nowrap;
  overflow: hidden;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  &:hover {
    opacity: 1;
  }

  &:focus {
    outline: none;
  }
`;

class ToolbarItem extends PureComponent {
  render() {
    const { icon, text, onClick, disabled } = this.props;
    return (
      <ToolbarListItem>
        <ToolbarButton disabled={disabled} onClick={onClick}>
          <ToolbarIcon>{icon || ""}</ToolbarIcon>
          {text}
        </ToolbarButton>
      </ToolbarListItem>
    );
  }
}

ToolbarItem.defaultProps = {
  icon: null,
  text: "",
  onClick: () => {},
  disabled: false
};

ToolbarItem.propTypes = {
  icon: PropTypes.element,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

export default ToolbarItem;



// WEBPACK FOOTER //
// ./app/components/Toolbar/ToolbarItem.js